/** Round pill toggle for multi-select groups (weekdays, filters). */
export function ToggleChip({
  pressed,
  onChange,
  label,
  disabled = false,
}: {
  pressed: boolean;
  onChange: (next: boolean) => void;
  label: string;
  disabled?: boolean;
}) {
  return (
    <button
      type="button"
      aria-pressed={pressed}
      disabled={disabled}
      className={`toggle-chip${pressed ? " toggle-chip--on" : ""}`}
      onClick={() => onChange(!pressed)}
    >
      {label}
    </button>
  );
}
